export default "__VITE_ASSET__DQk8u3o2__"